import { render, staticRenderFns } from "./ModalAddGudang.vue?vue&type=template&id=049c804a&scoped=true&"
import script from "./ModalAddGudang.vue?vue&type=script&lang=js&"
export * from "./ModalAddGudang.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddGudang.vue?vue&type=style&index=0&id=049c804a&lang=scss&scoped=true&"
import style1 from "./ModalAddGudang.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049c804a",
  null
  
)

export default component.exports